export default __webpack_public_path__ + "static/video-2bc9f79d81fd80f687a90809226a8378.mp4";